import { z } from "zod";

export const submittedBySchema = z.object({
  id: z.number(),
  name: z.string().nullish(),
});

export type SubmittedBy = z.infer<typeof submittedBySchema>;
